import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Pie } from "react-chartjs-2";
import { ControlLabel, FormControl } from 'react-bootstrap';

class EdumatStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment('2017-09-01T00:00:00.000Z'),
      endDate: moment(),
      edumats: null,
      activeEdumat: 'all',
      loaded: false,
    };

    this.handleChangeEdumat = this.handleChangeEdumat.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.state.loaded) {
      this.getEdumatStats();
      this.setState({
        loaded: true,
      });
    }
  }

  getEdumatStats() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      },
      params: {
        cache: true,
        access_token: loginToken,
      }
    };

    axios.get(this.props.api.stats.edumatStats, config)
      .then((response) => {
        if (!this._calledComponentWillUnmount) {
          this.setState({
            edumats: response.data
          });
        }
      }).catch(function (error) {
      console.error('Error axios:', error);
    });
  }

  handleChangeEdumat(event) {
    this.setState({
      activeEdumat: event.target.value,
    });
  }

  render() {
    const { activeEdumat, edumats } = this.state;

    const allEdumats = { correctAll: 0, finished: 0, unfinished: 0};
    for (const key in edumats) {
      if (edumats.hasOwnProperty(key)) {
        allEdumats.correctAll += edumats[key].correctAll || 0;
        allEdumats.finished += edumats[key].finished || 0;
        allEdumats.unfinished += edumats[key].unfinished || 0;
      }
    }

    const edumat = activeEdumat !== 'all' ? this.state.edumats[activeEdumat] : allEdumats;
    const chartData = {
      'labels': ['Zodpovězené úplně správně', 'Zodpovězené', 'Nezodpovězené'],
      'datasets': [
        {
          data: [
            edumat.correctAll,
            edumat.finished,
            edumat.unfinished
          ],
          backgroundColor: ['#9EE493', '#1ABB9C', '#9CC2CB']
        }
      ]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        display: false
      }
    };

    return (
      <div id="specialStats">
        <div>
          <h3>Vzdělávací materiály</h3>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="x-panel">
            <div className="x-title">
              <h2>Statistiky za vybrané období</h2>
              <div className="clearfix" />
            </div>
            <div className="x-content">
              <div className="row filter">
                <div className="col-xs-12 col-sm-6">
                  <ControlLabel>Vyberte vzdělávací materiál:</ControlLabel>
                  <FormControl componentClass="select" value={activeEdumat} onChange={this.handleChangeEdumat}>
                    <option value="all">Zobrazit vše</option>
                    {
                      edumats && Object.keys(edumats).map((key, index) => (
                        <option value={key} key={`edumat_option_${index}`}>{key}</option>
                      ))
                    }
                  </FormControl>
                </div>
                <div className="col-xs-12 col-sm-6"/>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <h5 className="graph-title">Graf</h5>
                  <Pie data={chartData} options={chartOptions} />
                </div>
                <div className="col-xs-12 col-sm-6">
                  <table className="tile-info">
                    <thead>
                    <tr>
                      <th>Vzdělávací materiály</th>
                      <th>Počet</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                      chartData.labels.map((label, index) =>
                        <tr key={`key_${label}`}>
                          <td>
                            <p><i className="fa fa-square"
                                  style={{ color: chartData.datasets[0].backgroundColor[index] }} />{label}</p>
                          </td>
                          <td>{chartData.datasets[0].data[index]}</td>
                        </tr>
                      )
                    }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EdumatStats;



/** WEBPACK FOOTER **
 ** ./src/containers/Statistics/EdumatStats.js
 **/